import { QueryClient, useQuery } from '@tanstack/react-query';
import { ContestApi } from 'api/ApiHelper';
import { contestsQueryKey } from 'queries/contests/queryKey';

export const useGetContestRepliesQuery = (contestId: number) =>
  useQuery({
    queryKey: contestsQueryKey.contestsReplies(contestId),
    queryFn: () => ContestApi.getContestReplies(contestId),
    enabled: contestId > 0,
    staleTime: 1000 * 60 * 5,
  });

export const prefetchContestRepliesQuery = (queryClient: QueryClient, contestId: number) =>
  queryClient.prefetchQuery({
    queryKey: contestsQueryKey.contestsReplies(contestId),
    queryFn: () => ContestApi.getContestReplies(contestId),
    staleTime: 1000 * 60 * 5,
  });
